import React from "react"

import { useContext, useState } from "react";
import { Link } from "react-router-dom";

import { useForm } from "antd/lib/form/Form";
import { Button, Col, Form, Grid, Input, Popconfirm, Row, Select, Tag } from "antd"

import { useQuery } from "@tanstack/react-query";

import Conjunto from "../../../../../Components/Conjunto";
import DestinoService from "../../../../../Services/Domain/Viagem/DestinoService";
import EscolaService from "../../../../../Services/Domain/Pessoa/EscolaService";
import Ordenar from "../../../../../Utils/Ordenacao";
import Permissoes from "../../../../../Constants/Permissoes";
import ResponsiveAntdTable from "../../../../../Components/ResponsiveAntdTable";
import Restrito from "../../../../../Components/Restrito";
import SessaoContext from "../../../../../Contexts/SessaoContext";
import StatusDaViagemService from "../../../../../Services/Domain/Viagem/StatusDaViagemService";
import TypeViagem from "../../../../../Models/Domain/Viagem/Viagem";
import ViagemService from "../../../../../Services/Domain/Viagem/ViagemService";
import { EnumStatusDaViagem, TypeStatusDaViagem } from "../../../../../Models/Domain/Viagem/StatusDaViagem";
import { PropriedadesDoPopConfirm } from "../../../../../Defaults";

import Formatacoes from "../../../../../Utils/Formatacao";
import InputDate from "../../../../../Components/Base/Input/InputDate";
import { SelectComPesquisa } from "@/Components/SelectComPesquisa";

export const ListagemDeViagens: React.FC<{
    aoEditar?: (viagem: TypeViagem) => any,
    aoSelecionarDetalhes?: (viagem: TypeViagem) => any,
    aoAdicionar?: () => any,

    hrefDoBotaoAdicionar?: string,
    hrefDoBotaoDetalhes?: (viagem: TypeViagem) => string | undefined
}> = (props) => {

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const tamanhoDaTela = Grid.useBreakpoint();
    const viagemService = new ViagemService();

    interface IFiltro {
        destino?: TypeViagem["destino"],
        escola?: TypeViagem["escola"],
        titulo?: TypeViagem["titulo"],
        de?: TypeViagem["inicio"],
        ate?: TypeViagem["fim"],
        status?: TypeViagem["status"],

        ativo?: TypeViagem["ativo"],
    }

    const [filtro, setFiltro] = useState<IFiltro>({
        ativo: true
    });

    const viagensDisponiveis = useQuery({
        queryKey: ["listarViagens", filtro],
        gcTime: 0,
        queryFn: () => viagemService.listarViagens({
            destino: filtro.destino,
            escola: filtro.escola,
            titulo: filtro.titulo,
            inicio: filtro.de,
            fim: filtro.ate,
            status: filtro.status,

            ativo: filtro.ativo,
        }),
        enabled: true,
    });

    const destinosDisponiveis = useQuery({
        queryKey: ["listarDestinos"],
        queryFn: () => new DestinoService().listarDestinos({ ativo: true, }),
        enabled: true,
    });

    const escolasDisponiveis = useQuery({
        queryKey: ["listarEscolas"],
        queryFn: () => new EscolaService().listar({ativo: true}),
        enabled: true,
    });

    const statusDisponiveis = useQuery({
        queryKey: ["listarStatusDisponiveis"],
        queryFn: () => new StatusDaViagemService().listarStatusDisponiveis(),
        enabled: true,
    });

    const onFinish = (valores: IFiltro) => {
        setFiltro({
            ...valores
        });
    }

    const [form] = useForm<IFiltro>();

    const adicionar = permissoes?.includes(Permissoes.CriarViagem);

    return <React.Fragment>
        <Form<IFiltro> form={form} onFinish={onFinish} layout='vertical' autoComplete='off'>
            <Row gutter={16}>

                <Col xs={24} md={24} xl={8}>
                    <Form.Item<IFiltro> name={["titulo"]} label="Título">
                        <Input placeholder="Todos" />
                    </Form.Item>
                </Col>


                <Col xs={24} md={12} xl={8}>
                    <Form.Item<IFiltro> name={["destino", "codigo"]} label="Destino">
                        <SelectComPesquisa
                            allowClear
                            placeholder={"Todos"}
                            loading={destinosDisponiveis.isFetching}
                            options={destinosDisponiveis.data?.data.map((item) => ( { value: item.codigo, label: item.nome }))} 
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8}>
                    <Form.Item<IFiltro> name={["escola", "codigo"]} label="Escola">
                        <SelectComPesquisa
                            allowClear
                            placeholder={"Todos"}
                            loading={escolasDisponiveis.isFetching}
                            options={escolasDisponiveis.data?.data.map((item) => ( { value: item.codigo, label: item.pessoa?.nomeExibicao }))} 
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["status", "codigo"]} label="Status">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={statusDisponiveis.data?.data.map((item) => ( { value: item.codigo, label: item.descricao }))} 
                            />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["de"]} label="De">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["ate"]} label="Até">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>


                <Col xs={24} md={6} xl={3}>
                    <Form.Item<IFiltro> name={["ativo"]} label="Ativo" initialValue={true}>
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={[
                                { value: true, label: "Ativo" },
                                { value: false, label: "Inativo" }
                            ]}
                            />
                    </Form.Item>
                </Col>

                <Col xs={adicionar ? 12 : 24} xl={adicionar ? 2 : 5} style={{ alignItems: 'end', display: 'flex' }}>
                    <Form.Item style={{ width: "100%" }}>
                        <Button type="primary" htmlType='submit' disabled={viagensDisponiveis.isFetching} style={{ width: "100%" }} >
                            Listar
                        </Button>
                    </Form.Item>
                </Col>

                <Restrito aberto={adicionar}>
                    <Col xs={12} xl={3} style={{ alignItems: 'end', display: 'flex' }}>
                        <Form.Item style={{ width: "100%" }}>
                            <Link to={props.hrefDoBotaoAdicionar ?? "#"} onClick={(e) => { !props.hrefDoBotaoAdicionar && e.preventDefault() }}>
                                <Button type="primary" onClick={() => { props.aoAdicionar?.() }} style={{ width: "100%" }}>
                                    Adicionar
                                </Button>
                            </Link>
                        </Form.Item>
                    </Col>
                </Restrito>
            </Row>
        </Form>

        <Row>
            <Col xs={24}>
                <ResponsiveAntdTable<TypeViagem, {}>
                    bordered
                    rowKey={(k) => k.codigo!}
                    locale={{ emptyText: 'Nenhuma viagem encontrada.' }}
                    loading={viagensDisponiveis.isFetching}
                    dataSource={viagensDisponiveis.data?.data}
                    addTitleOn="lg"
                    columns={[
                        {
                            title: "Código",
                            breakpoints: { xs: 24, sm: 12, xl: 2 },
                            dataIndex: "codigo",
                            key: "codigo",
                            sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                        },
                        {
                            title: "Titulo",
                            dataIndex: ["titulo"],
                            breakpoints: { xs: 24, sm: 12, xl: 4 },
                            key: "titulo",
                            sorter: (a, b) => Ordenar.String(a.titulo, b.titulo),
                        },
                        {
                            title: "Destino",
                            dataIndex: ["destino", "nome"],
                            breakpoints: { xs: 24, sm: 7, xl: 4 },
                            key: "destino",
                            sorter: (a, b) => Ordenar.String(a.destino?.nome, b.destino?.nome),
                        },
                        {
                            title: "Escola",
                            dataIndex: ["escola", "pessoa", "nomeExibicao"],
                            breakpoints: { xs: 24, sm: 7, xl: 3 },
                            key: "escola",
                            sorter: (a, b) => Ordenar.Numero(a.escola?.codigo, b.escola?.codigo),
                        },
                        {
                            title: "Datas",
                            breakpoints: { xs: 24, sm: 5, xl: 4 },
                            key: "datas",
                            render: (_, item ) => {
                                let inicio = Formatacoes.paraData(item.inicio)
                                let fim = Formatacoes.paraData(item.fim)
                                return <>{inicio?.toLocaleDateString() ?? "N/A"} : {fim?.toLocaleDateString() ?? "N/A"}</>
                            },
                        },
                        {
                            title: "Status",
                            dataIndex: ["status"],
                            breakpoints: { xs: 24, sm: 5, xl: 3 },
                            key: "status",
                            render: (v: TypeStatusDaViagem) => {

                                if (v.codigo == EnumStatusDaViagem.EM_ANDAMENTO) {
                                    return <Tag style={{width: "min-content"}} color="green">{v.descricao}</Tag>
                                } 

                                if (v.codigo == EnumStatusDaViagem.ENCERRADA) {
                                    return <Tag style={{width: "min-content"}} color="blue">{v.descricao}</Tag>
                                } 

                                if (v.codigo == EnumStatusDaViagem.CANCELADA) {
                                    return <Tag style={{width: "min-content"}} color="red">{v.descricao}</Tag>
                                } 

                                return v.descricao
                            },
                            sorter: (a, b) => Ordenar.String(a.status?.descricao, b.status?.descricao),
                        },
                        {
                            title: "Ações",
                            key: "acoes",
                            noResponsiveTitle: true,
                            breakpoints: { xs: 24, sm: 24, xl: 4 },
                            hidden: [Permissoes.AtualizarViagem, Permissoes.DesativarViagem, Permissoes.AtivarViagem].every((p) => !permissoes?.includes(p)),
                            render: (_, item) => {
                                return <Conjunto
                                    style={{ 
                                        justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: 'wrap' }}
                                    itens={
                                        (() => {
                                            if (item.ativo) {
                                                return [
                                                    <Link to={props.hrefDoBotaoDetalhes?.(item) ?? "#"}>
                                                        <Button 
                                                            size="small" 
                                                            onClick={() => props.aoSelecionarDetalhes?.(item)}
                                                        >
                                                            Detalhes
                                                        </Button>
                                                    </Link>,

                                                    permissoes?.includes(Permissoes.DesativarViagem) && (
                                                        <Popconfirm
                                                            {...PropriedadesDoPopConfirm("desativar")}
                                                            onConfirm={() => {
                                                                if (item.codigo == undefined) return;

                                                                viagemService
                                                                    .desativarViagem(item.codigo)
                                                                    .then(() => {
                                                                        viagensDisponiveis.refetch();
                                                                    })
                                                                    .catch(() => {});
                                                            }}
                                                        >
                                                            <Button type="default" danger size="small">
                                                                Desativar
                                                            </Button>
                                                        </Popconfirm>
                                                    ),
                                                ];

                                            } else {
                                                return [
                                                    permissoes?.includes(Permissoes.AtivarViagem) &&
                                                    <Popconfirm
                                                        {...PropriedadesDoPopConfirm("ativar")}
                                                        onConfirm={() => {
                                                            if (item.codigo == undefined) return;
                                                            
                                                            viagemService.ativarViagem(item.codigo)
                                                                .then(() => {
                                                                    viagensDisponiveis.refetch()
                                                                })
                                                                .catch(() => { })
                                                        }}
                                                    >
                                                        <Button type='dashed' size='small'>Reativar</Button>
                                                    </Popconfirm>
                                                ]
                                            }
                                        })()
                                    }
                                />
                            }
                        },

                    ]}
                    csv={{
                        enabled: true,
                        filename: "viagens.csv",
                        concat(source) {
                            return [
                                {
                                    header: "Status",
                                    data: source.map((v) => v.status?.descricao ?? "")
                                },
                                {
                                    header: "Início",
                                    data: source.map((v) => Formatacoes.paraData(v.inicio)?.toLocaleDateString() ?? "")
                                },
                                {
                                    header: "Término",
                                    data: source.map((v) => Formatacoes.paraData(v.fim)?.toLocaleDateString() ?? "")
                                },
                            ]
                        },
                    }}
                />
            </Col>
        </Row>

    </React.Fragment >

}

export default ListagemDeViagens
